import { Form, Input, Row, Col } from 'antd';
import type { MessageStructured } from '@/types/topic';

interface Props {
  value: MessageStructured;
  onChange: (next: MessageStructured) => void;
}

export function MessageForm({ value, onChange }: Props) {
  const set = <K extends keyof MessageStructured>(k: K, v: MessageStructured[K]) =>
    onChange({ ...value, [k]: v });

  return (
    <Form layout="vertical">
      <Row gutter={12}>
        <Col xs={24} md={12}>
          <Form.Item label="Author" style={{ marginBottom: 12 }}>
            <Input
              value={value.author ?? ''}
              onChange={(e) => set('author', e.target.value || null)}
              placeholder="e.g. GMCC CEO"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label="Publish date" style={{ marginBottom: 12 }}>
            <Input
              value={value.publish_date ?? ''}
              onChange={(e) => set('publish_date', e.target.value || null)}
              placeholder="YYYY-MM-DD"
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Summary" style={{ marginBottom: 0 }}>
        <Input.TextArea
          rows={3}
          value={value.summary ?? ''}
          onChange={(e) => set('summary', e.target.value || null)}
        />
      </Form.Item>
    </Form>
  );
}
